import { Action } from "@ngrx/store";
import { IUser, OTP_TYPES } from "src/app/models/user";

export enum EUserActions {
  LoginAttempt = "[Auth] Login Attempt",
  LoginAttemptSuccess = "[Auth] Login Attempt Success",
  LoginAttemptFailed = "[Auth] Login Attempt Failed",

  LoginOtpRequired = "[Auth::otp] Required",

  Logout = "[Auth] Logout",

  MeRequest = "[Me] Request",
  MeRequestOK = "[Me] Request OK",
  MeRequestFailure = "[Me] Request Failure",
}

export class LoginAttempt implements Action {
  public readonly type = EUserActions.LoginAttempt;
  constructor(
    public payload: {
      username?: string;
      password?: string;
      otp?: string;
      uuid?: string;
    },
  ) {}
}

export class LoginAttemptSuccess implements Action {
  public readonly type = EUserActions.LoginAttemptSuccess;
  constructor(public payload: IUser) {}
}

export class LoginAttemptFailed implements Action {
  public readonly type = EUserActions.LoginAttemptFailed;
  constructor(public payload: IUser) {}
}

export class LoginOtpRequired implements Action {
  public readonly type = EUserActions.LoginOtpRequired;
  constructor(public payload: OTP_TYPES) {}
}

export class Logout implements Action {
  public readonly type = EUserActions.Logout;
  constructor(public payload: any) {}
}

export class MeRequest implements Action {
  public readonly type = EUserActions.MeRequest;
  constructor(public payload: any) {}
}

export class MeRequestOK implements Action {
  public readonly type = EUserActions.MeRequestOK;
  constructor(public payload: IUser) {}
}

export class MeRequestFailure implements Action {
  public readonly type = EUserActions.MeRequestFailure;
  constructor(public payload: { errors: Array<string> }) {}
}
export type UserActions =
  | LoginAttempt
  | LoginAttemptSuccess
  | LoginAttemptFailed
  | Logout
  | MeRequest
  | MeRequestOK
  | MeRequestFailure
  | LoginOtpRequired;
